/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Upgrade_DescInputs */

const en_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access salary benchmarks, regional comparisons, and AI-powered negotiation scripts to maximize your earning potential.`)
};

const de_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greife auf Gehalts-Benchmarks, regionale Vergleiche und KI-gestützte Verhandlungsskripte zu, um dein Einkommenspotenzial zu maximieren.`)
};

const fr_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accède aux benchmarks salariaux, comparaisons régionales et scripts de négociation par IA pour maximiser ton potentiel de revenus.`)
};

const es_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceda a benchmarks salariales, comparaciones regionales y guiones de negociación con IA para maximizar su potencial de ingresos.`)
};

const it_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi a benchmark salariali, confronti regionali e script di negoziazione basati sull'AI per massimizzare il tuo potenziale di guadagno.`)
};

const nl_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegang tot salarisbenchmarks, regionale vergelijkingen en AI-gestuurde onderhandelingsscripts om je verdienpotentieel te maximaliseren.`)
};

const pl_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj dostęp do benchmarków wynagrodzeń, porównań regionalnych i skryptów negocjacyjnych opartych na AI, aby zmaksymalizować swój potencjał zarobkowy.`)
};

const fi_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä palkkatasoja, aluevertailuja ja tekoälypohjaisia neuvotteluskriptejä ansiomahdollisuuksiesi maksimoimiseksi.`)
};

const da_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få adgang til lønbenchmarks, regionale sammenligninger og AI-drevne forhandlingsscripts for at maksimere dit indtjeningspotentiale.`)
};

const sv_salary_upgrade_desc = /** @type {(inputs: Salary_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få tillgång till lönebenchmarks, regionala jämförelser och AI-drivna förhandlingsmanus för att maximera din intjäningspotential.`)
};

/**
* | output |
* | --- |
* | "Access salary benchmarks, regional comparisons, and AI-powered negotiation scripts to maximize your earning potential." |
*
* @param {Salary_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_upgrade_desc = /** @type {((inputs?: Salary_Upgrade_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Upgrade_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_upgrade_desc(inputs)
	if (locale === "fr") return fr_salary_upgrade_desc(inputs)
	if (locale === "es") return es_salary_upgrade_desc(inputs)
	if (locale === "it") return it_salary_upgrade_desc(inputs)
	if (locale === "nl") return nl_salary_upgrade_desc(inputs)
	if (locale === "pl") return pl_salary_upgrade_desc(inputs)
	if (locale === "fi") return fi_salary_upgrade_desc(inputs)
	if (locale === "da") return da_salary_upgrade_desc(inputs)
	if (locale === "sv") return sv_salary_upgrade_desc(inputs)
	return en_salary_upgrade_desc(inputs)
});